import React, { useEffect, useRef } from 'react';
import L from "leaflet";
import markerIconPng from "leaflet/dist/images/marker-icon.png";
import { Icon } from 'leaflet';
import ReactDOM from 'react-dom/client';

const EventMap = ({ lat, lng, locationName }) => {
    const mapRef = useRef(null);
    const mapId = 'event-map-leaflet';

    useEffect(() => {
        if (!mapRef.current) {
            const mapInstance = L.map(mapId, { scrollWheelZoom: false }).setView([lat, lng], 14);
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(mapInstance);

            const markerIcon = new Icon({
                iconUrl: markerIconPng,
                iconSize: [25, 41],
                iconAnchor: [12, 41]
            });

            const marker = L.marker([lat, lng], { icon: markerIcon }).addTo(mapInstance);
            if (locationName) {
                marker.bindPopup(locationName).openPopup();
            }

            mapRef.current = mapInstance;
        }

        return () => {
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, []);

    return <div id={mapId} style={{ height: '400px' }}></div>;
};

window.createEventMap = (containerId, lat, lng, locationName) => {
    const container = document.getElementById(containerId);
    if (container) {
        const root = ReactDOM.createRoot(container);
        root.render(<EventMap lat={lat} lng={lng} locationName={locationName} />);
    }
};

export default EventMap;
